import React, {useEffect , useState} from 'react';
import "./Gallery.scss";
import Slider from "react-slick";
import data from "./data.json"
import { mobile } from '../Services/Agent';


export default function Gallery() {

const [center, setCenter] = useState(1)

    const settings =  {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: mobile() ? "-20px" : "60px",
        slidesToShow: 3 ,
        focusOnSelect: true,
        className: "outer",
        speed: 500,
        afterChange: (index) => {
            setCenter(index + 1)
            console.log(center)
        }
      };
    
    //   if(mobile){
    //     settings.centerPadding = "-20px" 
    //     settings.slidesToShow = 3
    //     }

        console.log(settings)

    return (
        <section className="gallery-sec">
            {/* {
                mobile() ? 
                <img alt="" className="big_image" src={window.location.href +`./Photos/mobile/big/${center}.jpg`}/>
                :
                <img alt="" className="big_image" src={window.location.href + `./Photos/desktop/big/${center}.jpg`}/>
            } */}
            <img alt="" className={`big_image image${center}`} />
            
            <div className="bottom_wrapper">
                <div className="gallery_title">{data.data[center -1].title}</div>
                <a className="artile_btn" href={data.data[center -1].link} target="_blank"></a>
                <div className="gallery_wrapper">
            <Slider {...settings} >
                {
                    data.data.map((cell , index) => (
                        // mobile() ?
                        <div className="">
                        <img alt="" className={`img small-img${index+1}`} />  {/*window.location.href +*/}
                        </div>
                        // :
                        // <div><img alt="" className="img" data-gallery-id={index+1} src={`./Photos/desktop/${index + 1}.jpg`} /> </div>
                    ))
                }
            </Slider>
                    
                </div>
            </div>
        </section>
    )
}
